import { useState } from 'react'
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline'
import SwiperCore, { Navigation, Pagination } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import { Link } from "react-router-dom";

// eslint-disable-next-line react-hooks/rules-of-hooks
SwiperCore.use([Navigation, Pagination])

const TrendingCampaigns = () => {
  const [trendingCampaigns] = useState([
    {
      id: 1,
      title: "Old State Saloon Under Fire Help U...",
      category: "Community",
      image: "https://static2.givesendgo.com/images/campaign_image/9cc75f402a171f2809678373bbc6cd18.webp",
      raised: 4685,
      goal: 1000000000,
      lastDonation: "17 minutes ago",
      progress: 0.47
    },
    {
      id: 2,
      title: "Help The Chud And His Family",
      category: "Family",
      image: "https://static2.givesendgo.com/images/campaign_image/55ec63e815f6fff064c66c485a6b90d8.png",
      raised: 24711,
      goal: 100000,
      lastDonation: "41 minutes ago",
      progress: 24.71
    },
    {
      id: 3,
      title: "Defending The Truth",
      category: "Legal",
      image: "https://static2.givesendgo.com/images/campaign_image/85730e16292a0522ce0d9d16b70fe5ac.webp",
      raised: 79541,
      goal: 100000,
      lastDonation: "22 minutes ago",
      progress: 79.54
    },
    {
      id: 4,
      title: "In Loving Memory Of Christian Petr...",
      category: "Family",
      image: "https://static2.givesendgo.com/images/campaign_image/de06278d8e02aa8e41cfa96b807b9416.png",
      raised: 7625,
      goal: 15000,
      lastDonation: "2 hours ago",
      progress: 50.83
    },
    {
      id: 5,
      title: "Stand With Crystal",
      category: "Community",
      image: "https://static2.givesendgo.com/images/campaign_image/6252da9fd6c75c739832263341c26710.png",
      raised: 865,
      goal: 148800,
      lastDonation: "1 hour ago",
      progress: 0.58
    },
    {
      id: 6,
      title: "Reclaim Sex Based Rights For Women...",
      category: "Legal",
      image: "https://img.youtube.com/vi/uReIlB4nv70/hqdefault.jpg",
      raised: 0,
      goal: 0,
      lastDonation: "55 minutes ago",
      progress: 80
    }
  ])

  // Trending buttons
  const trendingButtons = [
    { label: "Hurricane Melissa Relief", href: "https://www.givesendgo.com/gsghurricanerelieffund" },
    { label: "Giving Tuesday", href: "https://www.givesendgo.com/giving-tuesday" }
  ]

  return (
    <>
      {/* Trending Buttons */}
      <section className="flex flex-col justify-center pb-0 md:pb-16 xl:pb-24 pt-14 md:pt-32">
        <div className="flex w-full flex-row flex-wrap justify-center mx-auto trending-button--wrapper">
          <div className="grid w-full lg:w-auto grid-cols-1 justify-items-center lg:grid-cols-2 gap-4">
            {trendingButtons.map((button, index) => (
              <a 
                key={index}
                href={button.href}
                className="trending-button bg-gsg-teal hover:bg-gsg-teal-dark text-white px-8 py-3 rounded-full font-semibold transition-all duration-300 transform hover:-translate-y-1"
              >
                {button.label}
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* Trending Campaigns Slider */}
      <section className="flex flex-col items-center pt-16 overflow-hidden pb-14 px-4">
        <h2 className="text-center text-3xl md:text-4xl font-bold text-gsg-gray-dark mb-4">
          Trending Campaigns
        </h2>
        
        <div className="flex flex-row flex-wrap justify-center w-full mt-8 space-x-14 max-w-7xl md:mt-16">
          <div className="relative w-full trendSlider">
            <div className="flex justify-between items-center mb-8">
              <button id="custom-prev" className="p-2 hover:bg-gray-100 rounded-full transition-colors">
                <ChevronLeftIcon className="w-8 h-8 text-gsg-teal" />
              </button>
              
              <button id="custom-next" className="p-2 hover:bg-gray-100 rounded-full transition-colors">
                <ChevronRightIcon className="w-8 h-8 text-gsg-teal" />
              </button>
            </div>

            <Swiper
              spaceBetween={15}
              slidesPerView={1}
              navigation={{
                nextEl: '#custom-next',
                prevEl: '#custom-prev',
              }}
              pagination={{ clickable: true }}
              breakpoints={{
                640: {
                  slidesPerView: 2,
                  spaceBetween: 20,
                },
                768: {
                  slidesPerView: 2,
                  spaceBetween: 30,
                },
                1024: {
                  slidesPerView: 3,
                  spaceBetween: 40,
                },
              }}
              className="mySwiper"
            >
              {trendingCampaigns.map((campaign) => (
                <SwiperSlide key={campaign.id}>
                  <div className="mb-2 rounded-lg shadow-md camp-card__wrapper">
                    {/* Campaign Image */}
                    <div 
                      className="relative camp-card__top"
                      style={{
                        backgroundImage: `linear-gradient(to right, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0.3) 100%), url(${campaign.image})`
                      }}
                    >
                      <div className="camp-card__top--category">
                        <span className="absolute">{campaign.category}</span>
                      </div>
                      <div className="flex flex-col space-y-1 goal__wrapper absolute bottom-4 left-4 text-white">
                        <div className="flex flex-row">
                          <p className="text-base">Raised:</p>
                          <p className="text-base">&nbsp;USD ${campaign.raised.toLocaleString()}</p>
                        </div>
                        {campaign.goal > 0 && (
                          <div className="flex flex-row">
                            <p className="text-base">Goal:</p>
                            <p className="text-base">&nbsp;USD ${campaign.goal.toLocaleString()}</p>
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Campaign Content */}
                    <div className="relative px-4 pt-6 pb-4 text-left camp-card__bottom">
                      {/* Progress Bar */}
                      <div className="absolute top-0 left-0 h-2 w-full bg-gray-300 rounded-t-lg">
                        <div 
                          className="h-full gradient__background rounded-t-lg"
                          style={{ width: `${campaign.progress}%` }}
                        ></div>
                      </div>

                      <h4 className="font-semibold text-lg text-gsg-gray-dark mb-3 overflow-clip">
                        {campaign.title}
                      </h4>
                      
                      <p className="text-base card-description text-gray-600 line-clamp-2 mb-4">
                        {/* Campaign description would go here */}
                        Supporting this important cause with your donations and prayers.
                      </p>

                      <p className="mt-4 text-sm text-center text-gray-400">
                        Last donation {campaign.lastDonation}
                      </p>

                     <div className="flex justify-center">
  <Link to="/campaignsdetails">
    <button className="btn--main w-32 mx-auto mt-4">
      Give
    </button>
  </Link>
</div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>

        {/* See More Button */}
        <div className="mt-16">
          <a href="/campaigns" className="inline-block btn--m btn--main px-8 py-3 rounded-full">
            See More Campaigns
          </a>
        </div>
      </section>
    </>
  )
}

export default TrendingCampaigns